import React, {useState, useEffect, useRef} from 'react';
import { useTranslation } from 'react-i18next';

//ICON
import icon from "../../../../assets/img/idioma.png";

//CSS
import styles from "./VTSelectLanguage.module.less";

function VTSelectLanguage({languages, selectedLanguage, setLanguage}) {
  const {t} = useTranslation("vtform");
  const languagenames = new Map ([['es',t('vtselectlanguage.Español')],['en',t('vtselectlanguage.Ingles')],['fr',t('vtselectlanguage.Frances')],['de',t('vtselectlanguage.Aleman')],['it',t('vtselectlanguage.Italiano')]]);
  const languagesContentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  let listLanguages=null;

  function handleLanguage (language) {
    setIsOpen(false);
    setLanguage(language);
  }

  function toggle(event) {
    if (languagesContentRef.current) {
      if (languagesContentRef.current.contains(event.target) && isOpen) return;
      setIsOpen((isOpen) => !isOpen);
    }
  }

  const handleClickOutside = (event) => {
    if (languagesContentRef.current) {
      if (languagesContentRef.current.contains(event.target)) return;
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  if (languages.length > 0) {
    listLanguages = languages.map((language, key) => {
      return (
        <section key={key} className={styles.language} onClick={() => handleLanguage(language)}>
         <input
           type="radio"
           name="language"
           value={language}
           defaultChecked={language === selectedLanguage ? true : false}
         />
          {languagenames.has(language) ? languagenames.get(language) : null}
      </section>
      )
    });
  }

  if (languages.length <= 0) return null;

  return (
    <div ref={languagesContentRef} className={styles.vtlanguages} onClick={toggle}>
      <img className={styles.icon} src={icon}/>
      {languagenames.has(selectedLanguage) ? languagenames.get(selectedLanguage) : null }
      {isOpen &&
        <div className={styles.languagesmodal} >
          {listLanguages}
        </div>
      }
    </div>
  );

}

export default VTSelectLanguage;